import {useMutation} from '../../../../common/hooks/QueryHooks';

const useShootForgotCode = () => {
	const {mutate, isLoading} = useMutation('/enterpriser/auth/forgot-password');

	const shoot = async (email?: string) => {
		if (!email) return;

		const data = {email};
		await mutate({data});
	};

	return {isLoading, shoot};
};

export default useShootForgotCode;
